export default {
    "WISHLIST": {
        "WISHLIST": "Kívánságlista",
        "WISHLISTS": "Kívánságlisták",
        "CATEGORY": "Kategória",
        "CATEGORIES": "Kategóriák",
        "NAME": "Név",
        "ACTIVE": "Aktív",
        "PURCHASE": "Vásárolt",
        "SCANCODE": "Scancode",
        "REFERRER": "Referált",
        "FILLEDOUT": "Befejezte",
        "SUM": "Összesen {sum} találat",
        "PURCHASED_AT": "Vásárolt",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/hu/wishlist.js